import { Space, Spin, Typography } from 'antd';
import { Header } from 'antd/lib/layout/layout';
import { PrimaryButton, SecondaryButton } from 'components';
import { useProfileInfoContext } from 'contexts/profileInfo';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';

const { Text } = Typography;

const ViewAsUserHeader = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state: profileData, isLoading } = useProfileInfoContext();

  const onEndSessionClick = () => {
    navigate('/admin');
  };

  return (
    <Header style={{ backgroundColor: '#FFFBE6', display: 'flex', justifyContent: 'space-between' }}>
      <Text>
        {t('admin.viewAsUser.viewingAs')}{' '}
        {isLoading ? (
          <Spin />
        ) : (
          <Text strong>
            {profileData?.firstName} {profileData?.lastName}
          </Text>
        )}
      </Text>
      <Space>
        <Link to="/admin/send-inbox-msg">
          <SecondaryButton size="middle">{t('admin.viewAsUser.sendMessage')}</SecondaryButton>
        </Link>
        <PrimaryButton size="middle" onClick={onEndSessionClick}>
          {t('admin.viewAsUser.endSession')}
        </PrimaryButton>
      </Space>
    </Header>
  );
};

export default ViewAsUserHeader;
